import styled from 'styled-components'
import theme from 'theme_'

export const ConfirmModalInner = styled.div`
  text-align: center;
  color: ${theme.colors.darkeyGrey};
`

export const ConfirmModalTitle = styled.div`
  text-transform: capitalize;
  margin-top: ${theme.spacing.base};
  color: ${theme.colors.otterWarmBlack};
`

export const ConfirmModalBody = styled.div`
  margin: ${theme.spacing.md} 0;
  color: ${theme.colors.otterWarmBlack};
  word-break: break-word;
  @media ${theme.devices.tablet} {
    margin: ${theme.spacing.xxxl} 0;
  }
`

export const ConfirmModalFooter = styled.footer`
  display: flex;
  flex-flow: column;

  > button {
    width: 100%;

    &:first-of-type {
      margin-top: ${theme.spacing.base};
      order: 1;
    }
  }

  @media ${theme.devices.tablet} {
    flex-flow: row;
    justify-content: center;
    gap: 20px;

    > button {
      width: auto;

      &:first-of-type {
        margin-top: 0;
        order: 0;
      }
    }
  }
`
